module.exports = __webpack_public_path__ + "logo.bf503f0863de57070ef4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 983
// module chunks = 2